export default __webpack_public_path__ + "static/media/revicon4.0010288a.svg";